import { useSiteClientsCounts } from 'features/networkAi/hooks'
import { useIntl } from 'react-intl'
import { networkStatusClientsMessages } from './messages'
import {
  NetworkStatusClientsContainer,
  NetworkStatusClientsHeader,
  NetworkStatusClientsHeaderTitle,
  NetworkStatusClientsBody,
  NetworkStatusClientsItem,
  NetworkStatusClientsCount,
  NetworkStatusClientsCountLabel,
} from './styles'

interface ClientsCardProps {
  siteId: string
}

function ClientsCard({ siteId }: ClientsCardProps) {
  const { formatMessage } = useIntl()
  const { wirelessTotal } = useSiteClientsCounts({ siteId })

  return (
    <NetworkStatusClientsContainer>
      <NetworkStatusClientsHeader>
        <NetworkStatusClientsHeaderTitle>
          Clients
        </NetworkStatusClientsHeaderTitle>
      </NetworkStatusClientsHeader>

      <NetworkStatusClientsBody>
        <NetworkStatusClientsItem>
          <NetworkStatusClientsCount>{wirelessTotal}</NetworkStatusClientsCount>
          <NetworkStatusClientsCountLabel>
            {formatMessage(networkStatusClientsMessages.wirelessTotalText)}
          </NetworkStatusClientsCountLabel>
        </NetworkStatusClientsItem>
      </NetworkStatusClientsBody>
    </NetworkStatusClientsContainer>
  )
}

export default ClientsCard
